import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ToastService } from "~app/common/components/toast/toast.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { SystemadministrationService } from "../../systemadministration.service";

@Component({
    selector: "rask-sysadm-virkesleverantorer",
    templateUrl: "./sysadm-virkesleverantorer.component.html",
    styleUrls: ["./sysadm-virkesleverantorer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        InputComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class SysadmVirkesleverantorerComponent {
    leverantorsId: number;
    momsnummer: string;
    momsnummerEjValiderad = false;
    momsnummerOk?: boolean;

    private readonly modalService = inject(RaskModalService);
    private readonly sysAdmService = inject(SystemadministrationService);
    private readonly toastService = inject(ToastService);

    validateAllVirkesleverantorerMomsregnr(): void {
        this.modalService.confirm(new ModalSettings("Validering av alla virkesleverantörer",
            "Är du säker på att du vill validera alla virkesleverantörers momsregistreringsnummer?"))
            .subscribe(x => {
                if (x === ConfirmDialogResponse.save) {
                    this.sysAdmService.validateMomsnummerForAllVirkesleverantorer().subscribe(result => {
                        this.toastService.add("Massor av 'MomsnummerValidering'-jobb har nu skapats");
                    });
                }
            });
    }

    validateMomsnummer(): void {
        this.sysAdmService.validateMomsnummer(this.momsnummer).subscribe(val => {
            if (val === "Giltigt") {
                this.momsnummerOk = true;
            } else if (val === "Ogiltigt") {
                this.momsnummerOk = false;
            } else {
                this.momsnummerEjValiderad = true;
            }
        });
    }
}
